<template>
    <div ref="alarmResponseContainer"
         class="md:mr-16 pb-16">
        <h5>Alarm Response</h5>
        <div v-if="sum > 0"
             class="w-full rounded-lg flex flex-col"
             :style="{ height: this.height }">
            <div class="">
                <!-- Response Time Container -->
                <div class="border-solid border-2 border-gray-800 bg-white inline-block -mr-1 p-0"
                     :style="{ width: this.widthResponse, height: this.height }">

                </div>

                <!-- Resolve Time Container -->
                <div class="border-solid border-2 border-gray-800 bg-blue-200 inline-block -mx-1 p-0"
                     :style="{ width: this.widthResolve, height: this.height }">
                </div>
            </div>
            <div class="flex flex-row justify-between">
                <div class="flex flex-row items-center md:mr-16 my-1">
                    <div class="pl-3 flex flex-col items-begin">
                        <span class="text-base font-normal text-gray-900">Response Time</span>
                        <span class="text-2xl font-semibold text-blue-600">{{ timeTillResponse }}</span>
                    </div>
                </div>
                <div class="flex flex-row items-center md:mr-16 my-1">
                    <div class="pl-3 flex flex-col items-begin">
                        <span class="text-base font-normal text-gray-900">Resolve Time</span>
                        <span class="text-2xl font-semibold text-blue-600">{{ timeTillResolvePostResponse }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="loading"
             class="flex flex-row items-center justify-center text-base text-center">
            <span>loading</span>
        </div>
        <div v-else
             class="flex flex-row items-center justify-center text-base text-center">
            <span>No Alarm Data Found</span>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";

const PHI = 1.618
const MAX_WIDTH = 100

export default {
    name: "AlarmResponseTime",
    mixins: [SonicuCoreMixin],
    props: {
        company: String,
    },
    data() {
        return {
            loading: true,
            timeTillResponse: 0,
            timeTillResolvePostResponse: 0,
        }
    },
    created() {
    },
    mounted() {
        axios.get(this.company.buildCompanyApiInternalRoute('alarms/response-time')).then(
            response => {
                this.loading = false
                this.timeTillResponse = response.data.responseTime
                this.timeTillResolvePostResponse = response.data.resolveTime

                this.$forceUpdate()
            }
        )
    },
    methods: {},
    computed: {
        sum() {
            return this.timeTillResponse + this.timeTillResolvePostResponse
        },
        widthResponse() {
            return (this.timeTillResponse / this.sum * MAX_WIDTH) + '%'
        },
        widthResolve() {
            return (this.timeTillResolvePostResponse / this.sum * MAX_WIDTH) + '%'
        },
        width() {
            return MAX_WIDTH + '%'
        },
        height() {
            if (this.loading) {
                return '0px';
            }
            if (!this.$refs.alarmResponseContainer) {
                return '0px'
            }
            return this.$refs.alarmResponseContainer.offsetWidth / PHI / 6 + 'px'
        },
    },
    beforeUnmount() {
    },
}

</script>



